import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'pk-broker-browser-denied',
	templateUrl: './browser-denied.component.html',
	styleUrls: ['./browser-denied.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BrowserDeniedModalComponent {}
